import format from 'date-fns/format';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import parseISO from 'date-fns/parseISO';
import {Glum} from '../../../puddleglum';

export type VoucherLike = Glum.Models.Voucher & {
	code?: string | null;
	voucher_code?: string | null;
};

export const voucherCode = (voucher: VoucherLike): string =>
	voucher.code || voucher.voucher_code || `Voucher #${voucher.id}`;

export const voucherServiceName = (voucher: VoucherLike): string =>
	voucher.price?.display_name ||
	voucher.price?.treatment?.treatment ||
	voucher.price?.treatment_group?.name ||
	'Service voucher';

export const voucherExpiry = (voucher: VoucherLike): string => {
	if (!voucher.expires_at) return 'No expiration';

	const expiresAt = parseISO(voucher.expires_at);
	if (Number.isNaN(expiresAt.getTime())) return 'No expiration';

	return `${format(expiresAt, 'MMM d, yyyy')} (${formatDistanceToNow(expiresAt, {addSuffix: true})})`;
};

export const statusColorForVoucher = (
	status: string,
): 'green' | 'orange' | 'blue' | 'red' | 'gray' => {
	if (status === 'active') return 'green';
	if (status === 'pending_payment') return 'orange';
	if (status === 'redeemed') return 'blue';
	if (status === 'canceled') return 'red';
	return 'gray';
};

export const statusLabelForVoucher = (status: string): string => {
	if (status === 'pending_payment') return 'Pending payment';
	if (status === 'redeemed') return 'Redeemed';
	if (status === 'canceled') return 'Canceled';
	return 'Active';
};
